<template>
  <div style="background-color: #F7F8FA;">
    <div class="headbg">
    </div>
    <div class="hot">
      <div class="tab">
        <div v-for="item in tablist" :key="item.id"  :class="{'tabitem': true, 'on': tabid === item.id}"  @click="change(item.id)">{{ item.text }}</div>
      </div>
      <Row :gutter="20">
        <Col :span="6" v-for="(item,index) in this.tabid === 1?datalist:datalist2" :key="index">
        <a @click="toggleFullscreen(index)">
          <div class="item">
            <div class="img">
              <img :src="item.img" alt="">
            </div>
            <div class="wrap">
              <h5>{{ item.title }}</h5>
              <p>{{ item.des }}</p>
              <svg t="1710741666828" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5375" width="26"
                   height="26">
                <path d="M769.906931 208.491475 811.109332 249.731738 208.499661 857.969593 167.29726 816.72933Z" p-id="5376"></path>
                <path d="M856.70274 420.186921 602.546226 166.030407 856.70274 166.030407Z" p-id="5377"></path>
              </svg>
            </div>
          </div>
        </a>
        </Col>
      </Row>
      <video ref="videoPlayer" controls v-if="show">
        <source type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data() {
    return {
      show: false,
      tabid: 1,
      tablist: [
        {
          id: 1,
          text: "全部",
        },
        {
          id: 2,
          text: "应急处置",
        },
      ],
      datalist: [
        {
          title: "线路客流特征分析实验",
          des: "OD数据的认识；断面客流计算；客流时空分布特征分析。",
          img: require("../../assets/home/pic01.png"),
          link: require("../../assets/video/线路客流特征分析.mp4"),
        },
        {
          title: "列车开行方案设计实验",
          des: "交路设置；全日分时段运力配置；运力负荷验算及优化。",
          img: require("../../assets/home/pic02.png"),
          link: require("../../assets/video/列车开行方案设计.mp4"),
        },
        {
          title: "运行图编制实验",
          des: "运行图铺画；车底周转计划编制；运行图仿真评估及优化。",
          img: require("../../assets/home/pic03.png"),
          link: require("../../assets/video/运行图编制.mp4"),
        },
        {
          title: "乘务计划编制实验",
          des: "乘务员分班设置；车次任务分配；乘务计划调整及优化。",
          img: require("../../assets/home/pic04.png"),
          link: require("../../assets/video/乘务计划编制.mp4"),
        },
        {
          title: "列车模拟驾驶实验",
          des: "驾驶室设备功能认知；驾驶操作学习。",
          img: require("../../assets/home/pic05.png"),
          link: require("../../assets/video/模拟驾驶.mp4"),
        },
        {
          title: "突发事件应急处置实验",
          des: "车站设备认知及操作；故障处理方式及流程学习。",
          img: require("../../assets/home/pic06.png"),
          link: require("../../assets/video/应急处置视频录制/车站大客流应急处置-综控员.mp4"),
        },
        {
          title: "车站设备运用与客流组织实验",
          des: "车站设施设备摆放；乘客进出站流线铺画；车站客流仿真。",
          img: require("../../assets/home/pic07.png"),
          link: require("../../assets/video/客流仿真.mp4"),
        },
        {
          title: "城轨列车运行能耗仿真实验",
          des: "列车运行操纵模式优化；运行能耗仿真及参数分析。",
          img: require("../../assets/home/pic08.png"),
          link: require("../../assets/video/城轨能耗仿真系统.mp4"),
        },
      ],
      datalist2: [
        {
          title: "火灾",
          // des: "OD数据的认识；断面客流计算；客流时空分布特征分析。",
          img: require("../../assets/home/pic01.png"),
          link: require("../../assets/video/应急处置视频录制/火灾.mp4"),
        },
        {
          title: "运营前准备工作-值班站长",
          // des: "交路设置；全日分时段运力配置；运力负荷验算及优化。",
          img: require("../../assets/home/pic02.png"),
          link: require("../../assets/video/应急处置视频录制/运营前准备工作-值班站长.mp4"),
        },
        {
          title: "站台门夹人-站务员",
          // des: "运行图铺画；车底周转计划编制；运行图仿真评估及优化。",
          img: require("../../assets/home/pic03.png"),
          link: require("../../assets/video/应急处置视频录制/站台门夹人-站务员.mp4"),
        },
        {
          title: "整侧站台无法关闭-站务员",
          // des: "乘务员分班设置；车次任务分配；乘务计划调整及优化。",
          img: require("../../assets/home/pic04.png"),
          link: require("../../assets/video/应急处置视频录制/整侧站台无法关闭-站务员.mp4"),
        },
      ],
    };
  },
  mounted() {
    this.addFullscreenListeners();
  },
  beforeDestroy() {
    this.removeFullscreenListeners();
  },
  setup() {},
  methods: {
    change(id) {
      this.tabid = id;
    },
    toggleFullscreen(index) {
      this.show = true;
      if (!document.fullscreenElement) {
        this.$nextTick(() => {
          if (this.tabid === 1) {
            this.$refs.videoPlayer.src = this.datalist[index].link;
          } else {
            this.$refs.videoPlayer.src = this.datalist2[index].link;
          }
          this.$refs.videoPlayer.requestFullscreen().catch((err) => {
            console.error("Error attempting to enable full-screen mode:", err);
          });
        });
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      }
    },
    addFullscreenListeners() {
      document.addEventListener(
        "fullscreenchange",
        this.handleFullscreenChange
      );
    },
    removeFullscreenListeners() {
      document.removeEventListener(
        "fullscreenchange",
        this.handleFullscreenChange
      );
    },
    handleFullscreenChange() {
      if (document.fullscreenElement === null) {
        // 视频已经退出全屏模式
        console.log("Exited fullscreen mode.");
        if (this.$refs.videoPlayer) {
          this.$refs.videoPlayer.src = "";
        }
        this.show = false;
        // 在这里添加退出全屏后的操作
      } else {
        // 视频进入全屏模式（如果需要，也可以在这里添加逻辑）
        console.log("Now in fullscreen mode!");
      }
    },
  },
};
</script>
<style lang="less" scoped>
.headbg {
  height: 250px;
  width: 100%;
  background: url(../../assets/banner3.png) no-repeat center;
  overflow: hidden;
}
.hot {
  width: 1200px;
  margin: 10px auto 0;
  .item {
    width: 270px;
    cursor: pointer;
    margin: 0 auto 20px;
    img {
      width: 270px;
      height: 180px;
      border-radius: 5px 5px 0 0;
      vertical-align: middle;
    }
    .img {
      position: relative;
      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 270px;
        height: 180px;
        background: rgba(0, 0, 0, 0.5) url("../../assets/video.png") no-repeat
          center;
        z-index: 222;
      }
    }
    .wrap {
      transition: 0.5s;
      height: 86px;
      position: relative;
      padding: 10px;
      svg {
        position: absolute;
        top: 10px;
        right: 0px;
        fill: #999;
        height: 20px;
        transition: 0.5s;
      }
    }
    h5 {
      font-size: 16px;
      color: #333;
      transition: 0.5s;
    }
    p {
      width: 100%;
      color: #666;
      font-size: 12px;
      line-height: 18px;
      margin-top: 6px;
      transition: 0.5s;
    }
  }
  a {
    &:hover {
      .wrap {
        background: #e12427;
        h5 {
          color: #fff;
        }
        p {
          color: #fff;
        }
        svg {
          fill: #fff;
        }
      }
    }
  }
}
.tab {
  display: flex;
  margin-bottom: 10px;
  // margin-left: 10px;
  .tabitem {
    padding: 0 5px;
    cursor: pointer;
  }
  .on {
    color: red;
  }
}
// .ivu-radio-group-button-solid .ivu-radio-wrapper-checked:not(.ivu-radio-wrapper-disabled){
//   background: red;
// }
// .ivu-radio-group-button .ivu-radio-wrapper-checked:first-child{
//   border-color: red;
// }
// .ivu-radio-group-button .ivu-radio-wrapper-checked{
//   border-color: red;
// }
// .ivu-radio-group-button .ivu-radio-wrapper-checked:before{
//   background: red;
// }
</style>

